import { DatePipe, Location } from '@angular/common';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DxDataGridComponent } from 'devextreme-angular';
import { exportDataGrid } from 'devextreme/excel_exporter';
import { saveAs } from 'file-saver-es';
import { Workbook } from 'exceljs';
import { Subject, takeUntil } from 'rxjs';
import { HhsgSharedAdminTab, HhsgSharedUserProfile} from '../../../models';
import {HhsgSharedCorporation} from '../../../models/corporation.model';
import {
  HhsgSharedClientAdminService,
  HhsgSharedConfigService,
  HhsgSharedLoadingService,
  HhsgSharedUserAdministratorService,
  HhsgSharedUserService
} from '../../../services';
import {HhsgSharedCorporationService} from '../../../services/corporation.service';
import {HhsgSharedUserAdminService} from '../../../services/user-admin.service';
import {Constants} from '../../../utilities/constants.util';
import {RoleUtil} from '../../../utilities/role.util';
import {DevExtremeUtils} from '../../../utilities/dev-extreme.util';
import {HhsgSharedTabInterface} from '../../common/tab-control/tab.interface';
import { HhsgSharedHeaderFilter } from '../../../models/header-filter.model';
import { HhsgSharedApplication } from '../../../models/application.model';
import { HhsgUserGridModel } from '../../../models/user-grid.model';

@Component({
  selector: 'hhsg-user-admin',
  templateUrl: './user-admin.component.html',
  styleUrls: ['./user-admin.component.scss']
})
export class HhsgSharedUserAdminComponent implements HhsgSharedTabInterface, OnDestroy, OnInit {
  @ViewChild('usersGrid', { static: false }) usersGrid: DxDataGridComponent;
  @Input() displayHeader: boolean = false;

  public corporations: HhsgSharedCorporation[] = [];
  public corporationUsersDataStore: any;
  public filterByCurrentApplication = false;
  public saveSuccessText: string[] = [];
  public dxStylingMode: string = DevExtremeUtils.DevExtremeStyleMode;

  private applicationAbbreviation: string;
  private confirmEnableUser = false;
  private isRootAdmin = false;
  private lockedOrDormantUserAction: string;
  private lockedOrDormantUserId: number;
  public selectedCorporationId: number;
  private selectedCorporationName: string;
  private sortedColumnNumber = 1;
  private statusList: { id: string; name: string; }[] = [];
  private user: HhsgSharedUserProfile;
  private _unsubscribe$ = new Subject<void>();
  applicationAbbreviationFilter: HhsgSharedHeaderFilter[] = [];
  clientNamesFilter: HhsgSharedHeaderFilter[] = [];
  tab: HhsgSharedAdminTab;
	
  private applicationsForFilter: HhsgSharedApplication[] = [];
    
  private allCorporation = new HhsgSharedCorporation();
  private userGridData: HhsgUserGridModel[];

  constructor(
    private _activatedRoute: ActivatedRoute,
    private _configService: HhsgSharedConfigService,
    private _corporationService: HhsgSharedCorporationService,
    private _datePipe: DatePipe,
    private _elementRef: ElementRef,
    private _location: Location,
    private _userService: HhsgSharedUserService,
    private _userAdminService: HhsgSharedUserAdminService,
    private _userAdministratorService: HhsgSharedUserAdministratorService,
    private _clientAdminService: HhsgSharedClientAdminService,
    private _router: Router,
    private _loadingService: HhsgSharedLoadingService) {
    this.applicationAbbreviation = this._configService.appSettings.applicationAbbreviation;
    this.filterByCurrentApplication = !this.isAppHap();
    this._userAdminService.selectedCorporationChangeSource$.subscribe(corporationId => {
      this.selectedCorporationId = corporationId;
      this.onCorporationChanged();
    });

    this._userAdminService.corporationExportSource$.subscribe(result => {
      if (result) {
        this.exportToExcel();
      }
    });
    this.allCorporation.name = "All";
    this.allCorporation.id = -1;
  }

    cancel(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
			return;
		});
    }
    isDisabled(): boolean {
        return false;
    }
    isFormDirty(): boolean {
      return false;
    }
    isFormValid(): boolean {
      return true;
    }
    reload(): void {
        
    }
    save(): Promise<number> {
        return new Promise<number>((resolve, reject) => {
			    return 1;
        });
    }

    public ngOnDestroy(): void {
      this._unsubscribe$.next();
      this._unsubscribe$.complete();
    }

  public async ngOnInit(): Promise<void> {
    this._loadingService.setLoading(true);

    if (this._userAdminService &&
      this._userAdminService.selectedCorporationId &&
      !isNaN(this._userAdminService.selectedCorporationId)) {
      this.selectedCorporationId = Number(this._userAdminService.selectedCorporationId);
      this.selectedCorporationName = this.selectedCorporationId === -1 ? "All" : this._userAdminService.selectedCorporation?.name;
    }

    this._userService.getUserProfile()
      .pipe(takeUntil(this._unsubscribe$))
      .subscribe((user: HhsgSharedUserProfile) => {
        this.user = user;
        this.isRootAdmin = user.isRootAdmin;
        this._corporationService.getAllActiveCorporations().then(corporations => {
          this.corporations = corporations;
          this.setCorporation();
          // Only Huron employees should see the "All" coproration option
          if (this.isHuronEmployee) {
            this.corporations.unshift(this.allCorporation);
          }
          this._loadingService.setLoading(false);
        });

      });

    this.createStatusList();

    this._activatedRoute.queryParams.subscribe(params => {
      if (params && params.showSuccess && params.showSuccess === 'true') {
        this.saveSuccessText.push(Constants.SaveSuccess);
        this._location.replaceState('/admin/user');
      }
    });
  } 

    private changeSortedColumnBackgroundColor(): void {
      this.clearPreviousColumnColor();

      var dataRows = this._elementRef.nativeElement.getElementsByClassName("dx-row");

      for (let index = 0; index < dataRows.length; index++) {
        if (dataRows[index].children[this.sortedColumnNumber]) {
          dataRows[index].children[this.sortedColumnNumber].classList.add("cell-highlighted");
        }
      }
    }

    private clearPreviousColumnColor(): void {
      var dataRows = this._elementRef.nativeElement.getElementsByClassName("cell-highlighted");

      for (let index = 0; index < dataRows.length; index++) {
        dataRows[index].classList.remove("cell-highlighted");
      }

      if (dataRows.length > 0) {
        dataRows[0].classList.remove("cell-highlighted");
          }
    }

    private createStatusList(): void {
      this.statusList = [{
        id: Constants.Synced,
        name: Constants.Synced
          },
          {
              id: Constants.Failed,
              name: Constants.Failed
          }];
    }

    public get errorMessages(): string[] {
	    return this._userAdminService.errorMessages;
    }

    public exportToExcel(): void {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Data');
        let fileName = this.getFileName();

        exportDataGrid({
            component: this.usersGrid.instance,
            worksheet,
            autoFilterEnabled: true
        }).then(() => {
            workbook.xlsx.writeBuffer().then((buffer) => {
                saveAs(new Blob([buffer], { type: 'application/octet-stream' }), fileName + '.xlsx');
            });
        });
	  }

    private getCorporationUsersByClients(): void {
      if (this.selectedCorporationId) {
        this._userAdministratorService
          .getUsersForCorporationByClients(this.applicationAbbreviation, this.filterByCurrentApplication)
          .pipe(takeUntil(this._unsubscribe$))
          .subscribe(result => {
            this.corporationUsersDataStore = result;            
            this.usersGrid.instance.clearFilter();
          this.initializeHeaderFilter();
          });
      }
    }

    private getCorporationUsers(): void {
      if (this.selectedCorporationId) {
        this._userAdminService
          .getUsersForCorporation(this.selectedCorporationId, this.applicationAbbreviation, this.filterByCurrentApplication)
          .pipe(takeUntil(this._unsubscribe$))
          .subscribe(result => {
            this.corporationUsersDataStore = result;            
            this.usersGrid.instance.clearFilter();
          this.initializeHeaderFilter();
          });
      }
    }

    public getFileName(): string {
      if (!this.selectedCorporationName) {
        return;
      }
      return this._datePipe.transform(Date(), 'yyyy-MM-dd') + '_' + this.selectedCorporationName + '_Users';
    }

  private getUsers(): void {
    if (this.isHuronEmployee) {
      this.getCorporationUsers();
      this.getAllCorporationUsers();
    }
    else {
      this.getCorporationUsersByClients();
      this.getAllCorporationUsersByClients();
    }
  }

  private getAllCorporationUsers(){
    if (this.selectedCorporationId) {
      this._userAdminService
        .getAllUsersForCorporation(this.selectedCorporationId, this.applicationAbbreviation, this.filterByCurrentApplication)
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe(result => {
          this.userGridData = result;
           this.initializeHeaderFilter();
        });
    }
  }

  private getAllCorporationUsersByClients(){
    if (this.selectedCorporationId) {
      this._userAdministratorService
        .getAllUsersForCorporationByClients(this.applicationAbbreviation, this.filterByCurrentApplication)
        .pipe(takeUntil(this._unsubscribe$))
        .subscribe(result => {
          this.userGridData = result;
          this.initializeHeaderFilter();
        });
    }
  }

    public isAppHap(): boolean {
        return this.applicationAbbreviation == Constants.HuronAcceleratorsAbbreviation;
    }

    public get isHuronEmployee(): boolean {
        if (!this.user) {
          return false;
        }

        return RoleUtil.isHuronEmployee(this.user.roles);
    }

  public async onConfirmEnableUser(): Promise<any> {
    this._userAdminService.errorMessages = [];
    this.confirmEnableUser = false;
    this._loadingService.setLoading(true);

    await this._userAdminService.enableUser(this.lockedOrDormantUserId).then(() => {
      this.getUsers();
    },
      (error) => {
        this._userAdminService.errorMessages.push(`Unable to ${this.lockedOrDormantUserAction} the user. ${error.error}`);
        this._userAdminService.formStatus = undefined;
      });

    this._loadingService.setLoading(false);
  }

  public onCorporationChanged(): void {
    this._userAdminService.formStatus = undefined;
    this._userAdminService.selectedCorporationId = this.selectedCorporationId;

    if (this.selectedCorporationId > -1) {
      this._userAdminService.selectedCorporation = this.corporations.find(x => x.id === this.selectedCorporationId);
      this.selectedCorporationName = this._userAdminService.selectedCorporation?.name;
    }
    else {
      this.selectedCorporationId = -1;
      this._userAdminService.selectedCorporation = null;
      this.selectedCorporationName = "All";
    }

    this.getUsers();
  }

    public onEditUser(userId: number): void {
    this._userService.childApplicationUser = null;
		this._userAdminService.formStatus = undefined;
		this._userAdminService.getAsUserModel(userId).then((user) => {
			this._userAdminService.selectedUser = user;

			if (!this._userAdminService.selectedCorporation) {
				this._userAdminService.selectedUserCorporation = this.corporations.find(x => x.id === user.corporationId);
			}

			this._router.navigate(['/', 'admin', 'user', 'edit', user.corporationId,userId]);
		});
	}

  public onEnableUser(userId: number, action: string): void {
    this.lockedOrDormantUserId = userId;
    this.lockedOrDormantUserAction = action;
    this.confirmEnableUser = true;
  }

  public onOptionChanged(events): void {
    if (events?.fullName?.includes("sort")) {
      this.sortedColumnNumber = events.fullName.charAt(8);
    }
  }

  private setCorporation(): void {
    if (this.selectedCorporationId) {
      this.getUsers();
      return;
    }

    if (this.isHuronEmployee) {
      this.selectedCorporationId = this.corporations.find(corporation => corporation.name.toUpperCase().trim() == "HURON").id;
    }
    else if (this.corporations.length === 1) {
      this.selectedCorporationId = this.corporations[0].id;
    }

    this.onCorporationChanged();
  }

    public setTableHeaderStyle(): void {
      if(this.usersGrid.instance.getDataSource()) {
        this.initializeHeaderFilter();
      }
      this.changeSortedColumnBackgroundColor()
    }

    public toggleFilterByCurrentApplication() {
      this.ngOnInit();
	    this.usersGrid.instance.clearFilter();

      // giving time to call this (this.initializeHeaderFilter) method 
      // because gridInstance will take time to generate
      setTimeout(()=> this.initializeHeaderFilter(), 1000);
    }

    public viewCorporations(): boolean {
        return this.isHuronEmployee;
    }
    
    private initializeHeaderFilter(): void {
      let applications: string[] = [];
      let clients: string[] = [];

      if (this.userGridData != null){
        this.userGridData.forEach(corporationUser => {        
          if(corporationUser != null){
            const application = corporationUser.applicationAbbreviations?.split(",");
            const client = corporationUser.clientNames?.split(",");
            clients.push(...client);
            applications.push(...application);
          }
        });
      }      

      applications = [...new Set(applications.map(a => a.trim()))];
      applications.sort();
      clients = [...new Set(clients.map(c => c.trim()))];
      clients.sort();

      this.applicationAbbreviationFilter = this.gridHeaderFilter(applications, 'applicationAbbreviations');
      this.clientNamesFilter = this.gridHeaderFilter(clients, 'clientNames');
    }

    private initializeHeaderFilterOrig(): void {
      let applications: string[] = [];
      let clients: string[] = [];


      let _dataUser = this.usersGrid.instance.getDataSource();
      if (_dataUser != null){
        _dataUser['_items'].forEach(corporationUser => {        
          if(corporationUser != null){
            const application = corporationUser.applicationAbbreviations?.split(",");
            const client = corporationUser.clientNames?.split(",");
            clients.push(...client);
            applications.push(...application);
          }
        });
      }

      

      applications = [...new Set(applications.map(a => a.trim()))];
      clients = [...new Set(clients.map(c => c.trim()))];

      this.applicationAbbreviationFilter = this.gridHeaderFilter(applications, 'applicationAbbreviations');
      this.clientNamesFilter = this.gridHeaderFilter(clients, 'clientNames');
    }
    

    private gridHeaderFilter(headerFilterNames: string[], headerFilterValue: string): HhsgSharedHeaderFilter[] {
      const headerFilters: HhsgSharedHeaderFilter[] = [];
      headerFilterNames.forEach(name => {
        const headerFilter: HhsgSharedHeaderFilter = {
          text: (name == '') ? '(Blanks)' : name,
          value: (name == '') ? '' : [headerFilterValue, 'contains', name]
        };
        headerFilters.push(headerFilter)
      });
      return headerFilters;
    }

    public addUser() {
      this._router.navigate(['/', 'admin', 'user', 'edit', this.selectedCorporationId,'-1' ]);
    }
}
